import { render, staticRenderFns } from "./TestOrdersResultSetup.vue?vue&type=template&id=a0ae4484&"
import script from "./TestOrdersResultSetup.vue?vue&type=script&lang=js&"
export * from "./TestOrdersResultSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports